<template>
  <div class="navbar-container">
    <Navbar
      :onToggleMenu="onSwitchToggleMenu"
      :user="currentUser">
      <!-- navbard view show on mobile only -->
      <router-link slot="navbar-brand"
        class="navbar-brand"
        :to="generateHomepageLink()" >
        <img src="@/assets/image/logo-lighthouse.png"
          class="logo mr-1" width="28"
        />
        <span>Lighthouse <small>beta</small></span>
      </router-link>
      <!-- slot for serach component -->
      <ul slot="navbar-nav-search"
        class="navbar-nav navbar-nav-search">
        <li class="nav-item active">
          <Search
            v-model="selectedVideo"
            :data="videos"
            :disabled="isEmptyProjects"
            @onSelectedSearchResult="selectResult"
            :onChange="onSearchChange" />
        </li>
      </ul>
      <!-- Addon Menu -->
      <div slot="menu-user"
        class="menu-user">
        <a class="nav-item" :href="`${baseURL}/accounts/logout?team=${teamName}`">
          <i class="fas fa-sign-out-alt"></i>&nbsp;Logout
        </a>
      </div>
    </Navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadVideos } from '@/video/api';
import generateLink from '@/utils/generateLink';
import Navbar from '@/components/Navbar.vue';
import Search from '@/components/Search.vue';

export default {
  props: {
    onToggleMenu: {
      type: Function,
      default: () => {},
    },
    stateSidebar: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [generateLink],
  components: {
    Navbar,
    Search,
  },
  data() {
    return {
      selectedVideo: null,
      videos: [],
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'isEmptyProjects', 'currentProject']),
    baseURL() {
      return process.env.VUE_APP_ORIGIN || window.location.origin;
    },
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    onCloseToggleMenu() {
      this.onToggleMenu(false);
    },
    onSwitchToggleMenu() {
      this.onToggleMenu(!this.stateSidebar.isMobileMenuShowing);
    },
    generateHomepageLink() {
      if (this.projectId && this.currentProject) {
        return `/${this.teamName}/projects/${this.currentProject.projectId}/summary`;
      }
      return `/${this.teamName}/projects`;
    },
    onSearchChange(searchQuery) {
      if (searchQuery && searchQuery.length > 1) {
        const filter = { q: searchQuery };
        this.loadVideo(filter);
      } else if (!searchQuery) {
        this.loadVideo();
      }
    },
    selectResult(selectedOption) {
      this.onToggleMenu();
      const url = this.generateLink(`/${this.teamName}/projects/${this.currentProject.projectId}/videos/${selectedOption.videoId}`, this.$route.query);
      this.$router.push(url);
    },
    async loadVideo(filter) {
      const response = await loadVideos(filter);
      this.videos = response.data.data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
